import encHex from 'crypto-js/enc-hex';
import CryptoJS from 'crypto-js';
import padZeroPadding from 'crypto-js/pad-zeropadding'
import setCookie, {getCookie, removeCookie} from './functions/cookies';

var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
    return cipherParams;
  }
}

export default function loginHandle() {
  const form = document.getElementById('loginForm');

  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      e.stopPropagation();

      const loginData = new FormData(form);
      loginData['user'] = form.querySelector('input#user').value;

      const passwd = form.querySelector('input#password').value;
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(passwd), "wBYI18ofBbf85nZXZIsTZRnxKGqjxp", {format: CryptoJSAesJson}).toString();
      loginData['password'] = encrypted;

      fetch('/wp-json/secure/v1/login', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      })
      .then(resp => resp.json())
      .then(async resp => {
        setCookie('jwt', resp.token, 7);
        location.reload();
      });
    })
  }

  if(!getCookie('subscriber') && getCookie('jwt')) {
    autoConnect();
  } else if(getCookie('subscriber') && !getCookie('jwt')) {
    removeCookie('subscriber')
  }
}

const autoConnect = () => {
  fetch('/wp-json/secure/v1/jwt', {
    method: 'get',
  })
  .then(resp => resp.json())
  .then(async resp => {
    setCookie('subscriber', JSON.stringify(resp), 7);
  });
}
